{
  "settings": "设置",
  "yourDigitalAssistant": "您的在线自助客服",
  "getStarted": "开始交谈",
  "login": "登录",
  "loggingIn": "在登录 ...",
  "darkMode": "护眼模式",
  "clearHistory": "删除历史记录",
  "historyCleared": "历史已清除",
  "changeLanguage": "语言",
  "termsAndConditions": "条款和条件",
  "messagePlaceholder": "请在这里输入您想说的话 ...",
  "messagePlaceholderDisabled": "输入禁止...",
  "feedbackTitle": "请您对本次服务进行评价",
  "feedbackPlaceholder": "向我们反馈（可选项）",
  "feedbackSend": "发送",
  "feedbackClose": "关",
  "sessionExpired": "您的本次会话已过期。",
  "startNewSession": "开始新的会话",
  "apiError": "糟糕！出了点问题。我们正在努力尽快修复此问题。",
  "apiErrorOffline": "您未连接到互联网。",
  "tryAgain": "再试一次",
  "startOver": "重新开始",
  "chatEnded": "聊天已结束。",
  "chatEndedThankYou": "感谢您与我们聊天！",
  "closeChat": "关",
  "startNewChat": "再聊一次",
  "humanTakeoverStarted": "您现在正在转移到客户服务...",
  "humanTakeoverQueued": "等待连接到代理",
  "humanTakeoverAnAgent": "代理商",
  "humanTakeoverAgentEntered": "进入对话",
  "humanTakeoverAgentLogout": "离开了对话",
  "humanTakeoverTransfer": "您将被转移到新代理",
  "humanTakeoverEnded": "您现在正在与数字助理聊天",
  "version": "版",
  "formIntroText": "请填写以下表格,开始与我们聊天。",
  "formFirstName": "名字",
  "formLastName": "姓氏",
  "formName": "名称",
  "formEmail": "电子邮件",
  "formWrongEmail": "请提供有效的电子邮件地址。",
  "formPhone": "电话",
  "formShipmentId": "货件ID",
  "formQuestion": "您的问题",
  "formAccountNumber": "帐号（针对企业客户）",
  "formAddress": "地址",
  "formPostcode": "邮政编码",
  "formCity": "市",
  "formCountry": "国家",
  "formSubmitButton": "开始聊天",
  "formEmptyFieldError": "不允许为空。",
  "formPhoneNumberValidationError": "无效的电话号码。",
  "formInputIsBiggerThan50": "最多50个字符。",
  "formInputIsBiggerThan100": "最多为100个字符。",
  "formInputIsBiggerThan2000": "最多为2000个字符。",
  "widgetEventOnline": "DA消息: 用户重新联机。",
  "widgetEventHidden": "DA消息: 窗口小部件已隐藏。",
  "widgetEventVisible": "DA消息: 窗口小部件可见。",
  "widgetEventVisibleMinimized": "DA消息: 窗口小部件可见，但已最小化。",
  "widgetEventMinimized": "DA消息: 小部件已最小化。",
  "widgetEventMaximized": "DA消息: 小部件已最大化。",
  "widgetEventSessionExpired": "DA消息: 小部件会话已过期。",
  "widgetEventHangupHuman": "DA 消息：用户结束人工接管会话。",
  "widgetEventUserTyping": "DA消息：用户正在输入。",
  "fileTooLarge": "您正在尝试附加太大的文件。",
  "tooManyDiles": "您正在尝试附加太多文件。",
  "fileInvalidType": "您正在尝试附加无效的文件类型。",
  "attachmentsDropHere": "放在这里上传或",
  "attachmentsBrowse": "浏览文件",
  "attachmentsExtenstionQuantity": "pdf或图像（最多10个文件）",
  "attachmentsSize": "高达30 MB",
  "attachmentsFailedUploading": "上载失败",
  "attachmentsUploading": "上载中...",
  "minimizeExpandText": "立即與我們實時聊天！",
  "popupWidgetNotificationMessage": "您收到一条新消息！",
  "tabWidgetNotificationMessage": "新消息！",
  "datepickerSendButton": "发送"
}
